import type {ReplyAttemptResult} from './replyAttempts'

export type NewEmailState={draft:{subject:string;body:string;senderMailboxId:string};attempt?:{id:string;fingerprint:string}}
const prefix='avertsignal:new-email:'
const key=(scope:string,contactId:string)=>`${prefix}${encodeURIComponent(scope)}:${encodeURIComponent(contactId)}`
export function readNewEmailState(scope:string,contactId:string):NewEmailState|undefined{
  try{
    const value=JSON.parse(localStorage.getItem(key(scope,contactId))||'null') as NewEmailState|null
    if(!value||typeof value.draft?.subject!=='string'||typeof value.draft.body!=='string'||typeof value.draft.senderMailboxId!=='string')return
    if(value.attempt&&(!/^[a-f0-9-]{36}$/i.test(value.attempt.id)||!/^[a-f0-9]{64}$/i.test(value.attempt.fingerprint)))return
    return value
  }catch{return}
}
export function saveNewEmailState(scope:string,contactId:string,value:NewEmailState){
  localStorage.setItem(key(scope,contactId),JSON.stringify(value))
  if(JSON.stringify(readNewEmailState(scope,contactId))!==JSON.stringify(value))throw Error('email_attempt_storage_unavailable')
}
export function purgeNewEmailStates(scope:string){
  const start=`${prefix}${encodeURIComponent(scope)}:`
  try{for(const name of Object.keys(localStorage))if(name.startsWith(start))localStorage.removeItem(name)}catch{/* Retired effects still cannot write; protected-state clearing must continue. */}
}
export async function newEmailFingerprint(intent:{actorId:string;workspaceId:string;contactId:string;senderMailboxId:string;recipient:string;subject:string;body:string}){
  const bytes=new TextEncoder().encode(JSON.stringify([intent.actorId,intent.workspaceId,intent.contactId,intent.senderMailboxId,intent.recipient.trim().toLowerCase(),intent.subject.trim(),intent.body.trim()]))
  const digest=await crypto.subtle.digest('SHA-256',bytes)
  return [...new Uint8Array(digest)].map(byte=>byte.toString(16).padStart(2,'0')).join('')
}
export function newEmailAttemptLabel(result:ReplyAttemptResult){
  if(result.recipientRoleMismatch)return 'Recovery mismatch: provider To/Cc/Bcc roles differ from the captured attempt. Acceptance of this exact intent is unverified; do not resend.'
  if(result.attemptState==='NOT_RESERVED')return 'No durable email reservation found. Retry this attempt.'
  if(result.providerAccepted)return result.persistencePending?'Microsoft accepted the message; CRM history reconciliation pending.':'Microsoft accepted the message; CRM history recorded.'
  if(result.acceptanceUnknown)return 'Send outcome uncertain. Check email status; do not resend.'
  if(result.safeToRetry)return 'Send failed before acceptance. Retry the unchanged email attempt.'
  return 'Email pending. Check email status before another send.'
}
